<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdh-30px pdb-0 hauteur-haut-affectation">
      <div class="level border-entete">
        <div class="level-left">
          <p class="has-text-link is-size-4 has-text-weight-bold">
            {{ $t('chargeTravailAff.ressourceAndAffectationInfo.titleAffectation') }}
          </p>
        </div>
        <div class="level-right is-cursor-pointer">
          <div @click="$emit('close')">
            <b-icon icon="close"
                    type="is-link"
                    size="is-small"
                    class="mgv-auto"></b-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless is-paddingless
    hauteur-affectation-information">
      <div class="pdh-30px pdb-20px">
        <div class="mgt-5px">
          <afficheurTitle @updateAfficheurSelect="selectAfficheur('faceNonAffecte', null, null)"
                          :afficheurInformation="{
          afficheurId: null,
          afficheur: $t('chargeTravailAff.ressourceAndAffectationInfo.faceNonAffecte'),
          nbFaces: nbFaceSansTournee,
          }"
                          :isIconSelect="afficheurSelect.id === 'faceNonAffecte'"
                          :displayLogo="true"
                          :firstLigne="true">
          </afficheurTitle>
        </div>
      </div>
      <div class="pdh-30px pdb-20px">
        <div class="mgt-5px">
          <afficheurTitle @updateAfficheurSelect="selectAfficheur('addAfficheur', null, null)"
                          :afficheurInformation="{
          afficheurId: null,
          afficheur: $t('chargeTravailAff.actions.addAfficheur'),
          nbFaces: null}"
                          :isIconSelect="afficheurSelect.id === 'addAfficheur'"
                          :displayLogo="false"
                          :firstLigne="false">
          </afficheurTitle>
        </div>
      </div>
      <div v-for="(afficheurInformation, index) in ressources" :key="index">
        <div class="pdh-30px pdb-20px">
          <afficheurTitle @updateAfficheurSelect="
          selectAfficheur(afficheurInformation.afficheurId, null, null)"
                          :firstLigne="false"
                          :isIconSelect="afficheurSelect.afficheurId
                          === afficheurInformation.afficheurId"
                          :displayLogo="true"
                          :afficheurInformation="afficheurInformation"
                          :nbListes="getListeAffichageByAfficheurId(
                                afficheurInformation.afficheurId)"
          ></afficheurTitle>
          <div class="card border-color-select border-top-none"
                v-for="(tournee, indexAffichage) of afficheurInformation.listeAffichage"
                :key="indexAffichage">
              <div class="card-content pd-0">
                <div class="content">
                  <detail-tournee-affichage
                    @updateAfficheurSelect="selectAfficheur"
                    :tourneeDate="tournee.dateDepart"
                    :index="indexAffichage"
                    :afficheurSelect="afficheurSelect"
                    :afficheurId="afficheurInformation.afficheurId"
                    :isIconSelect="afficheurSelect.afficheurId === afficheurInformation.afficheurId
                      && tournee.dateDepart === afficheurSelect.date"
                    :tourneeAffichage="tournee">
                  </detail-tournee-affichage>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-ressourceAffectation">
      <button @click="$emit('close')"
              class="button mgt-15px is-size-7 has-text-link">
        {{ $t('general.button.close') }}
      </button>
    </div>
  </div>
</template>

<script>

import afficheurTitle from '@/components/logistique/chargeTravail/affichage/affectation/afficheurTitle';
import detailTourneeAffichage
  from '@/components/logistique/chargeTravail/affichage/affectation/detailTourneeAffichage';

export default {
  props: {
    ressources: {
      required: true,
      type: Array,
    },
    nbFaceSansTournee: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      afficheurSelect: {
        id: null,
        date: null,
        tourneeId: null,
      },
    };
  },
  methods: {
    selectAfficheur(afficheurId, date, tourneeId, tourneeLibelle, otId) {
      this.afficheurSelect = {
        afficheurId: afficheurId,
        date: date,
        tourneeId: tourneeId,
        tourneeLibelle: tourneeLibelle,
        otId: otId,
      };
      this.$emit('openAffectationPopUp', this.afficheurSelect);
    },
    getListeAffichageByAfficheurId(id) {
      const ressource = this.ressources.filter(resource => resource.afficheurId === id);
      const nbListe = ressource.reduce((acc, val) => {
        return acc + val.listeAffichage.length;
      }, 0);
      return nbListe;
    },
  },
  components: {
    afficheurTitle,
    detailTourneeAffichage,
  },
};

</script>
